import { getAppState, subscribe } from "./state.js";
import { mountApp, render } from "./ui.js";
import { mountFormsAdmin } from "./formsAdminApp.js";

const root = document.getElementById("app");

if (!root) {
  throw new Error("Missing #app root");
}

function isFormsAdminPath() {
  const path = (location.pathname || "/").replace(/\/+$/, "") || "/";
  return path === "/formsadmin" || path.endsWith("/formsadmin");
}

if (isFormsAdminPath()) {
  document.documentElement.classList.add("is-forms-admin");
  mountFormsAdmin(root).finally(() => {
    document.documentElement.classList.add("is-ready");
  });
} else {
  mountApp(root);

  function refresh() {
    render(root, getAppState());
  }

  subscribe(refresh);
  refresh();
  document.documentElement.classList.add("is-ready");
}
